
<template>
  <span>
    <span class="valid-wrap" :class="{
      'is-invalid': !!props.errorMessage,
      'disable-autofill-bg-color': props.disableAutofillBgColor
    }">
      <slot></slot>
    </span>
    <span v-if="!props.noDisplayErrorMessage" :style="props.errorMessageStyle" class="valid-error-message">
      <template v-if="props.errorMessage">
        <span v-for="(line, idx) in props.errorMessage.split(`\n`)" :key="idx">{{ line }}<br/></span>
      </template>
    </span>
  </span>
</template>

<script lang="ts">
export default {
  name: 'ValidationMessage',
}
</script>

<script setup  lang="ts">
import type { StyleValue } from 'vue'

const props = withDefaults(defineProps<{
  errorMessage?: string,
  noDisplayErrorMessage?: boolean,
  errorMessageStyle?: StyleValue,
  disableAutofillBgColor?: boolean,
}>(), {
  noDisplayErrorMessage: false,
  disableAutofillBgColor: false,
})

</script>
<style scoped lang="scss">
.is-invalid {
  // エラーあり
  :deep(input),
  :deep(textarea),
  :deep(select) {
    // inputなどの背景色を赤くする
    background-color: rgba(222, 66, 66, 0.6) !important; // #DE4242
  }
  & + .valid-error-message {
    // エラーメッセージ
    font-size: 0.75rem;
    color: #DE4242;
    padding-left: 1rem;
    line-height: 1.5rem;
    display: block;
    text-align: left;
    &::before {
      content: '※';
    }
  }
}
.disable-autofill-bg-color {
  // オートコンプリートのデザインを無効にする
  :deep(input:-webkit-autofill) {
    // ブラウザ指定のデザインを打ち消すために白くする
    background-color: unset !important;
    box-shadow: 0 0 0 1000px white inset;
  }
  &.is-invalid {
    // エラーありの場合、赤くする
    :deep(input:-webkit-autofill) {
      background-color: unset !important;
      box-shadow: 0 0 0 1000px rgba(222, 66, 66, 0.6) inset;
    }
  }
}
</style>
